// Shared categories list (kept in sync with backend articles.py CATEGORIES)
export const CATEGORIES = [
  { slug: "formula-1", name: "Formula 1" },
  { slug: "wec", name: "WEC" },
  { slug: "imsa", name: "IMSA" },
  { slug: "gt-world-challenge", name: "GT World Challenge" },
  { slug: "formula-e", name: "Formula E" },
  { slug: "indycar", name: "IndyCar" },
  { slug: "nascar", name: "NASCAR" },
  { slug: "motorsport-business", name: "Motorsport Business" },
  { slug: "opinion", name: "Opinion" },
];

export const CATEGORY_MAP = CATEGORIES.reduce((acc, c) => {
  acc[c.slug] = c.name;
  return acc;
}, {});
